import { Announcement } from 'api/queries/announcements'

const STORAGE_KEY = 'NEXTROUND_READ_ANNOUNCEMENTS'

export const announcementReadKey = ({ id, updatedAt }: Pick<Announcement, 'id' | 'updatedAt'>): string =>
  `${id}:${updatedAt}`

export const getReadAnnouncementKeys = (): Set<string> => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? '[]')
    return new Set(Array.isArray(stored) ? stored.filter(value => typeof value === 'string') : [])
  } catch {
    return new Set()
  }
}

export const getUnreadAnnouncements = (announcements: Announcement[]): Announcement[] => {
  const readKeys = getReadAnnouncementKeys()
  return announcements.filter(announcement => !readKeys.has(announcementReadKey(announcement)))
}

export const markAnnouncementsRead = (announcements: Announcement[]): void => {
  try {
    const readKeys = getReadAnnouncementKeys()
    announcements.forEach(announcement => readKeys.add(announcementReadKey(announcement)))
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(readKeys).slice(-250)))
  } catch {
    // Reading updates must keep working if storage is unavailable or full.
  }
}
